export default {
    contractList: {
        title: 'Aktivne pogodbe',
        newContractAria: 'Ustvari novo pogodbo',
        loadErrorTitle: 'Pogodb ni bilo mogoče naložiti',
        loadErrorBody: 'Napaka omrežja — poskusite znova',
        tryAgain: 'Poskusi znova',
        emptyTitle: 'Ni aktivnih pogodb',
        emptyBody: 'Ustvarite svojo prvo pogodbo z obrazcem na desni strani.',
        emptyCta: 'Ustvarite svojo prvo pogodbo',
        filterEmptyTitle: 'Nobena pogodba ne ustreza tem filtrom',
        filterEmptyBody: 'Poskusite odstraniti filter ali razširiti obseg datumov.',
        clearFilters: 'Počisti filtre',
    },
}
